import useSWR from 'swr'

import { FetchError } from '../../../data/fetchError'
import { FetchResponse } from '../../../data/fetchResponse'
import { FetchResult } from '../../../data/fetchResult'
import { fetchJson } from '../../../data/fetchers'
import {
  DeliveryForecast,
  DeliveryForecastItem,
  DeliveryForecastItemForecast,
  WebEdiDeliveryForecastDto,
} from '../../../data/models'
import { useConfigContext } from '../../ui-config'

export function useAllDeliveryForecasts(): FetchResult<
  WebEdiDeliveryForecastDto<DeliveryForecast>[]
> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDeliveryForecastDto<DeliveryForecast>[]>,
    FetchError
  >(
    `/deliveryforecasts?includeItems=true`,
    fetchJson<WebEdiDeliveryForecastDto<DeliveryForecast>[]>,
    {
      refreshInterval: pollingConfig.intervalInSeconds * 1000,
    },
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useDeliveryForecastById(
  id: string,
): FetchResult<WebEdiDeliveryForecastDto<DeliveryForecast>> {
  const { pollingConfig } = useConfigContext()
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<WebEdiDeliveryForecastDto<DeliveryForecast>>,
    FetchError
  >(
    `/deliveryforecasts/${id}`,
    fetchJson<WebEdiDeliveryForecastDto<DeliveryForecast>>,
    {
      refreshInterval: pollingConfig.intervalInSeconds * 1000,
    },
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useAllDeliveryForecastItems(
  deliveryForecastId: string,
): FetchResult<DeliveryForecastItem[]> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastItem[]>,
    FetchError
  >(
    `/deliveryforecasts/${deliveryForecastId}/items`,
    fetchJson<DeliveryForecastItem[]>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useDeliveryForecastItemById(
  deliveryForecastId: string,
  id: string,
): FetchResult<DeliveryForecastItem> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastItem>,
    FetchError
  >(
    `/deliveryforecasts/${deliveryForecastId}/items/${id}`,
    fetchJson<DeliveryForecastItem>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useAllDeliveryForecastItemForecasts(
  deliveryForecastId: string,
  deliveryForecastItemId: string,
): FetchResult<DeliveryForecastItemForecast[]> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastItemForecast[]>,
    FetchError
  >(
    `/deliveryforecasts/${deliveryForecastId}/items/${deliveryForecastItemId}/forecasts`,
    fetchJson<DeliveryForecastItemForecast[]>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useDeliveryForecastItemForecastById(
  deliveryForecastId: string,
  deliveryForecastItemId: string,
  id: string,
): FetchResult<DeliveryForecastItemForecast> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<DeliveryForecastItemForecast>,
    FetchError
  >(
    `/deliveryforecasts/${deliveryForecastId}/items/${deliveryForecastItemId}/forecasts/${id}`,
    fetchJson<DeliveryForecastItemForecast>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
